import { useEffect, useState, useCallback } from 'react';
import { Loading } from './PokladnaUi';
import { fmtKc } from './PokladnaPrehledTab';
import Dropdown from '../../components/receptura/Dropdown';

const STAV_BADGE = {
    otevrena:        { c: '#f59e0b', l: 'Otevřená' },
    castecne_strzena:{ c: '#3b82f6', l: 'Částečně sražena' },
    zaplacena:       { c: '#10b981', l: 'Zaplacená' },
    odepsana:        { c: '#6b7280', l: 'Odepsaná' },
};

export default function PokladnaPohledavkyTab({ cardStyle, isDark, refreshKey, isCeo, onResit }) {
    const [pohledavky, setPohledavky] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filtr, setFiltr] = useState({ stav: '' });

    const load = useCallback(() => {
        setLoading(true);
        const qs = new URLSearchParams(Object.entries(filtr).filter(([, v]) => v));
        fetch('/api/finance/pokladna/pohledavky?' + qs, { credentials: 'same-origin' })
            .then(r => r.ok ? r.json() : Promise.reject(r.status))
            .then(setPohledavky).catch(console.error).finally(() => setLoading(false));
    }, [filtr]);
    useEffect(() => { load(); }, [load, refreshKey]);

    return (
        <div className="space-y-3">
            <div className="flex items-end gap-2 rounded-2xl p-3" style={cardStyle}>
                <div className="flex flex-col">
                    <label className="text-xs mb-1" style={{ color: 'var(--text-tertiary)' }}>Stav</label>
                    <Dropdown value={filtr.stav} onChange={v => setFiltr({ stav: v })}
                        options={[{ value: '', label: 'Vše' }, { value: 'otevrena', label: 'Otevřené' }, { value: 'castecne_strzena', label: 'Částečně sražené' }, { value: 'zaplacena', label: 'Zaplacené' }, { value: 'odepsana', label: 'Odepsané' }]}
                        isDark={isDark} accent="#3B82F6" height={32} minWidth={150} />
                </div>
            </div>

            <div className="rounded-2xl overflow-hidden" style={cardStyle}>
                {loading ? <Loading /> : (
                    <table className="w-full text-xs">
                        <thead><tr className="text-[10.5px] font-bold uppercase tracking-wide" style={{ color: 'var(--text-tertiary)', textAlign: 'left', borderBottom: '1px solid var(--border-default)' }}>
                            <th className="py-2 px-3">Vznikla</th><th>Zaměstnanec</th><th>Typ</th>
                            <th className="text-right">Částka</th><th className="text-right">Sraženo</th><th className="text-right">Zbývá</th>
                            <th>Stav</th><th>Důvod</th><th></th>
                        </tr></thead>
                        <tbody>
                            {pohledavky.length === 0 && (
                                <tr><td colSpan={9} className="py-4 text-center" style={{ color: 'var(--text-tertiary)' }}>Žádné pohledávky.</td></tr>
                            )}
                            {pohledavky.map(p => {
                                const stav = STAV_BADGE[p.stav] ?? { c: '#6b7280', l: p.stav };
                                const aktivni = p.stav === 'otevrena' || p.stav === 'castecne_strzena';
                                return (
                                    <tr key={p.id} style={{ borderTop: '1px solid var(--border-default)', color: 'var(--text-primary)' }}>
                                        <td className="py-1.5 px-3">{p.vznikla_dne}</td>
                                        <td>{p.zamestnanec ? `${p.zamestnanec.jmeno} ${p.zamestnanec.prijmeni}` : '—'}</td>
                                        <td><span className="text-xs px-1.5 py-0.5 rounded" style={{ background: 'var(--surface-base)' }}>{p.typ}</span></td>
                                        <td className="text-right">{fmtKc(p.castka_kc)}</td>
                                        <td className="text-right">{fmtKc(p.strzeno_kc)}</td>
                                        <td className="text-right font-medium">{fmtKc(p.zbyva_kc)}</td>
                                        <td><span style={{ background: stav.c + '22', color: stav.c, padding: '1px 8px', borderRadius: 6, fontSize: 10, fontWeight: 500 }}>{stav.l}</span></td>
                                        <td style={{ color: 'var(--text-tertiary)' }}>{p.duvod?.slice(0, 50) ?? '—'}</td>
                                        <td>
                                            {aktivni && (
                                                <button onClick={() => onResit(p)}
                                                    className="px-2 py-1 rounded text-xs"
                                                    style={{ background: 'var(--surface-base)', color: 'var(--text-primary)', border: '1px solid var(--border-default)' }}>Řešit</button>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
            </div>
            {!isCeo && (
                <p className="text-xs" style={{ color: 'var(--text-tertiary)' }}>Pohledávky odpisuje pouze CEO (superadmin).</p>
            )}
        </div>
    );
}
